
import { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import {
    FaSearch
  } from "react-icons/fa";
import "./styles.css";

import { useNavigate } from "react-router-dom";

const SearchInput = (props) =>{

    const {query, setQuery, to} = props;

    const navigate = useNavigate();
    const goTo = () => navigate(to);

    useEffect(() => {
        setQuery(query)
    }, [query])

    return(
        <>
        <Form className="d-flex" onSubmit={e => { e.preventDefault(); }}>
            <Form.Control
                type="search"
                placeholder="Catálogo"
                className="me-2"
                aria-label="Search"
                autoComplete="off"
                onChange={event => setQuery(event.target.value)}
                value={query}
            />
            <Button 
                variant="primary"
                style={{ border:"1px solid white" }}
                onClick={goTo}
            >
                <FaSearch size={20} />{' '}
            </Button>{' '}
        </Form>
        </>
    )

}

export default SearchInput;